var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"public-page"},[_c('PublicNavbar'),_vm._t("default"),_c('PublicFooter')],2)}
var staticRenderFns = []

export { render, staticRenderFns }